/**
 * Detect if buyers use broswer autocomplete to fill up the form
 *
 * https://github.paypal.com/ConsumerWeb-R/ProgressiveContent/pull/1735
 */
const browserAutocompleteCallback = (e, cb) => {
  setTimeout(() => {
    let isBrowserAutoComplete = false;
    try {
      isBrowserAutoComplete = e.target.matches(':-webkit-autofill');
    } catch (err) {
      // eslint-disable-next-line max-len
      const mozAutofillFilter = /^grayscale\(.*\) brightness\(.*\) contrast\(.*\) invert\(.*\) sepia\(.*\) saturate\(.*\)$/gi;
      const compStyle = window.getComputedStyle(e.target);
      if (mozAutofillFilter.test(compStyle.filter)) {
        isBrowserAutoComplete = true;
      }
    }

    if (isBrowserAutoComplete) {
      cb?.();
    }
  }, 0);
};

export { browserAutocompleteCallback };
